module.exports = __webpack_public_path__ + "img/number_2.eee3b99e.png";